import ShippingAddress from './shipping_address';
import {setOrFallbackValue} from './helper';
import ADDRESS_TYPES from '../../constants/address_types';

class FittingStationAddress extends ShippingAddress {
    constructor(properties) {
        super(properties);
        this.addressType = setOrFallbackValue(properties, 'addressType', ADDRESS_TYPES.BUSINESS);
    }
}

export default FittingStationAddress;
